import React, { useEffect, useRef, useState } from "react";
import PaymentItem from "./PaymentCustomer/PaymentItem";
import PaymentTextarea from "./PaymentCustomer/PaymentTextarea";
import Image from "next/image";
import themes from "../../themes/themes";
import { Field, Formik, useFormik, useFormikContext } from "formik";
import { PosSheme } from "../../validations/PosSheme";
import Input from "./Payment/Input";
import { useTranslation } from "../../context/TranslationContext";
import DefaultCurrencyFormat from "../DefaultCurrencyFormat";
import { CheckPaymentStatus, CreateHashData, GetPaymentStatus } from "../api";
import { useRouter } from "next/router";
import ReservationsLoading from "../Loaders/ReservationsLoading";
import { toast } from "react-toastify";
import { RiShieldCheckFill } from "@react-icons/all-files/ri/RiShieldCheckFill";
import { b64_sha1 } from "../../helper/hex_sha1";
import axios from "axios";
import { DetectCardNumber } from "../DetectCardNumber";
import Installement from "./Payment/Installement";
import { makeid } from "../../helper/makeid";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const SinglePaymentPage = ({ ssr }) => {
  const formRef = useRef(null);
  const { select, dateMonth, dateYear } = useTranslation();

  const [installement, setInstallement] = useState([]);
  const [formData, setFormData] = useState({});
  const router = useRouter();
  const [isSuccess, setIsSuccess] = useState(false);
  const [response, setResponse] = useState(null);
  const {
    dear,
    paymentStatusChecking,
    paymentSuccessToast,
    successTitle,
    paymentReceived,
    paymentInfoSentTo,
    contactAndPaymentInfo,
    fullNameLabel,
    creditCardInfo,
    cardNumberLabel,
    loadingShort,
    payBtn,
    sslNotice,
  } = useTranslation();
  function sortObjectKeys(obj) {
    // Objeden tüm anahtarları al
    const keys = Object.keys(obj);

    // Anahtarları alfabetik olarak sırala (büyük/küçük harf duyarlı)
    keys.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

    // Yeni bir obje oluştur
    const sortedObj = {};

    // Sıralanmış anahtarlara göre yeni objeyi doldur
    keys.forEach((key) => {
      sortedObj[key] = obj[key];
    });

    return sortedObj;
  }

  const HandleSubmit = async (values, actions) => {
    values.VirtualPosId = ssr.result.VirtualPosId;
    if (values.VirtualPosId == 3 && values.installement <= 1) {
      values.VirtualPosId = 4;
    }
    if (values.VirtualPosId == 3) {
      const conversationId = makeid(20);
      await axios
        .post("/api/PaymentWithoutReservation", {
          ...values,
          _: conversationId,
        })
        .then((result) => {
          if (result.data.success) {
            NativeFancybox.show(
              [
                {
                  id: "xx111",
                  src: "/api/PaymentForm?_=" + conversationId,
                  type: "iframe",
                  preload: false,
                  width: 500,
                  height: 700,
                },
              ],
              {
                on: {
                  closing: function () {
                    const toastId = toast.loading(paymentStatusChecking);
                    CheckPaymentStatus(conversationId)
                      .then((e) => {
                        if (e.data.status == "success") {
                          setResponse(e.data);
                          setIsSuccess(true);
                          toast.success(paymentSuccessToast);
                        }
                      })
                      .finally(() => {
                        toast.dismiss(toastId);
                      });
                  },
                },
              },
            );

            //setPaymentHtml(JSON.stringify(result.data));
            //setPaymentHtml(atob(result.data.threeDSHtmlContent));
            //Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
          } else {
            toast.error(result.data.error);
          }
        })
        .catch((e) => {
          toast.error(e.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } else {
      await CreateHashData(values)
        .then(async (e) => {
          const data = e.data.data;
          const random = Math.floor(Math.random() * 1000000000);
          const newFormData = {
            pan: values.cardNumber.replaceAll("-", ""),
            Ecom_Payment_Card_ExpDate_Month: values.month,
            Ecom_Payment_Card_ExpDate_Year: values.year,
            cv2: values.cvv,
            odeme_tipi: "Kredi Kartı",
            clientid: data.ClientId,
            amount: data.Amount,
            sipBil: random,
            rnd: random,
            okUrl: data.OkUrl,
            failUrl: data.FailUrl,
            TranType: data.Auth,
            callbackUrl: data.callback,
            Instalment: data.Installment,
            storetype: "3D_PAY",
            hashAlgorithm: "ver3",
            lang: "tr",
            currency: values.currency,
            BillToName: values.name,
            BillToCompany: values.name,
            Expiry: values.month + values.year,
            VirtualPosId: values.VirtualPosId,
            harici: "1",
            isim: values.name,
            telefon: values.phone,
            mesaj: values.message,
            gonder: "Ödemeyi Yap",
            ...values,
          };
          delete newFormData.cardNumber;

          await axios
            .post(process.env.NEXT_PUBLIC_API + "/CreateForm", newFormData)
            .then((e) => {
              if (e.status == 200) {
                setFormData(
                  sortObjectKeys({
                    ...newFormData,
                    ip: e.data.ip,
                    HASH: e.data.hash,
                  }),
                );
                setTimeout(() => {
                  formRef.current.submit();
                }, 200);
              }
            });
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    }
  };

  useEffect(() => {
    if (router.query?.h) {
      const toastId = toast.loading(paymentStatusChecking);
      GetPaymentStatus(router.query.h)
        .then((e) => {
          const r = JSON.parse(e.data.data.Response);

          if (r?.ProcReturnCode == "00") {
            setResponse(r);
            setIsSuccess(true);
            toast.success(paymentSuccessToast);
          }

          if (r.mdErrorMsg && r?.ProcReturnCode !== "00") {
            toast.error(r.mdErrorMsg);
          }
        })
        .finally(() => {
          toast.dismiss(toastId);
        });
    }
  }, [router.query.h]);

  return (
    <div className="flex justify-center mx-4">
      <div className="my-5 drop-shadow-lg bg-white w-[800px] ">
        <div className="flex py-5 justify-center">
          <div className=" relative">
            <Image src={themes.logo} width={240} height={90} alt="Logo" />
          </div>
        </div>
        {isSuccess ? (
          <div className="flex w-full justify-center items-center text-center flex-col mb-10">
            <div>
              <RiShieldCheckFill
                size={96}
                className="text-green-500"
              ></RiShieldCheckFill>
              <span className="font-bold text-lg text-green-500 mt-2">
                {successTitle}
              </span>
            </div>
            <span className="text-sm text-brand-gray-2">
              {paymentReceived}
            </span>
            <hr className="h-0.25 bg-gray-100 w-full my-4"></hr>
            <p className="text-sm text-brand-gray text-center leading-6">
              <strong className="text-black font-extrabold">
                {response.email}
              </strong>{" "}
              {paymentInfoSentTo}
              <br></br>
            </p>
          </div>
        ) : (
          <>
            <Formik
              initialValues={{
                name: "",
                email: "",
                phone: "",
                price: "",
                message: "",
                currency: "949",
                cardNumber: "",
                month: "",
                year: "",
                cvv: "",
                installement: 1,
              }}
              validationSchema={PosSheme}
              onSubmit={HandleSubmit}
            >
              {(props) => (
                <form
                  onSubmit={props.handleSubmit}
                  className="flex flex-wrap p-5"
                >
                  <div className="flex justify-center py-3 text-15 font-extrabold bg-[#f8f9fa] mb-2  w-full">
                    <span>{contactAndPaymentInfo}</span>
                  </div>
                  <div className="relative z-0  group p-1 my-2 w-full">
                    <Input name="name" placeholder=" " label={fullNameLabel} />
                  </div>
                  <div className="relative z-0  group p-1 my-2 w-full">
                    <Input name="email" placeholder=" " label={"Email"} />
                  </div>
                  <div className="relative z-0  group p-1 my-2 w-full">
                    <Input name="phone" placeholder=" " label={"Telefon"} />
                  </div>
                  <div className="relative z-0  group p-1 my-2 w-full">
                    <Input name="message" placeholder=" " label={"Mesaj"} />
                  </div>
                  <div className="relative z-0 w-3/4 group p-1 my-2">
                    <Input name="price" placeholder=" " label={"Tutar"} />
                  </div>
                  <div className="relative z-0 w-1/4 group p-1 my-2">
                    <Field
                      as="select"
                      name="currency"
                      className={
                        "border-gray-300 block rounded-md py-5 px-6 w-full   text-[0.875rem] bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary " +
                        (!props.errors.currency && props.touched.currency
                          ? "border-green-500 focus:!border-green-500"
                          : "") +
                        (props.errors.currency && props.touched.currency
                          ? " border-red-500 focus:!border-red-500"
                          : " ")
                      }
                    >
                      {ssr.result.Currencies.map((e, i) => (
                        <option value={e.PosCode} key={i}>
                          {e.CurrencyCode}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <div className="flex justify-center py-3 text-15 font-extrabold bg-[#f8f9fa] w-full mt-5">
                    <span>{creditCardInfo}</span>
                  </div>
                  <div className="relative z-0 w-full group p-1 my-2">
                    <Input
                      name="cardNumber"
                      placeholder=" "
                      label={cardNumberLabel}
                      mask="____-____-____-____"
                      replacement={{ _: /\d/ }}
                    />
                  </div>
                  <div className="relative z-0 w-full group p-1 my-2 -mt-5">
                    <Installement
                      installement={installement}
                      handleChange={props.handleChange}
                      paymentDetails={{ Symbol: "₺" }}
                    />
                  </div>
                  <div className="grid grid-cols-3 gap-x-4 p-1 w-full">
                    <div className="relative z-0 mb-6 w-full group">
                      <Input
                        name="month"
                        placeholder="- -"
                        label={dateMonth}
                        mask="__"
                        replacement={{ _: /\d/ }}
                      />
                    </div>
                    <div className="relative z-0 mb-6 w-full group">
                      <Input
                        name="year"
                        placeholder="- -"
                        label={dateYear}
                        mask="__"
                        replacement={{ _: /\d/ }}
                      />
                    </div>
                    <div className="relative z-0 mb-6 w-full group">
                      <Input
                        name="cvv"
                        placeholder="- - -"
                        label={"CVC"}
                        mask="___"
                        replacement={{ _: /\d/ }}
                      />
                    </div>
                  </div>
                  <span className="text-red-500 font-bold text-xl mx-auto">
                    {installement.find(
                      (x) => x.installmentNumber == props.values.installement,
                    )?.totalPrice ? (
                      <DefaultCurrencyFormat
                        value={
                          installement.find(
                            (x) =>
                              x.installmentNumber == props.values.installement,
                          )?.totalPrice
                        }
                        Symbol={
                          ssr.result.Currencies.find(
                            (e) => e.PosCode === props.values.currency,
                          ).Symbol
                        }
                      />
                    ) : (
                      <DefaultCurrencyFormat
                        value={props.values.price}
                        Symbol={
                          ssr.result.Currencies.find(
                            (e) => e.PosCode === props.values.currency,
                          ).Symbol
                        }
                      />
                    )}
                  </span>
                  {ssr.result.VirtualPosId == 3 && (
                    <DetectCardNumber setInstallement={setInstallement} />
                  )}
                  <button
                    type="submit"
                    disabled={props.isSubmitting || !props.isValid}
                    className="mt-3 w-full text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:opacity-90 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm  text-center disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {props.isSubmitting ? loadingShort : payBtn}
                  </button>

                  <div className="flex justify-center w-full mt-20">
                    <img
                      src="/images/visamaster.jpg"
                      className="w-[490px] h-[148px]"
                      alt=""
                    />
                  </div>
                  <div className="p-4 rounded bg-[#fff3cd] text-[12px] sm:text-[16px] mx-2 mb-4">
                    <span>
                      {sslNotice
                        .replace("{domain}", process.env.NEXT_PUBLIC_DOMAIN)
                        .replace("{site}", process.env.NEXT_PUBLIC_SITENAME)}
                    </span>
                  </div>
                </form>
              )}
            </Formik>
            <form
              ref={formRef}
              action={
                ssr.result.VirtualPosSettings.Action ||
                "https://sanalpos.halkbank.com.tr/fim/est3Dgate"
              }
              method="post"
            >
              {Object.keys(formData).map((key) => (
                <input
                  key={key}
                  type="hidden"
                  readOnly
                  name={key}
                  value={formData[key]}
                />
              ))}
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default SinglePaymentPage;
